import * as ServerOperations from "@/Common/Operations/operations.server";
import { ServerEvent } from "@/Common/Stores/Actions/ServerEvent";
import { BaseServerOperationHandler } from "@/Common/Stores/Handlers/Server/BaseServerOperationHandler";
import { FlowsheetSummary } from "@/Flowsheets/Models/FlowsheetSummary";
import { FlowsheetTemplate } from "@/Flowsheets/Models/FlowsheetTemplate";
import { PatientStore } from "@/Patient/Stores/PatientStore";

class FlowsheetsResponseHandler extends BaseServerOperationHandler {
    constructor(action: any) {
        super(action);

        this.RegisterOperation(
            ServerOperations.Server.Myle_FlowsheetModule_FindFlowsheetSummaries,
            this.loadFlowsheetSummaries
        );
    }

    private loadFlowsheetSummaries(response: ServerEvent, store: PatientStore): void {
        if (response.hasErrors())
            return;

        const flowsheets: FlowsheetSummary[] = response.Data.Data?.map(flowsheet => new FlowsheetSummary({
            Id: flowsheet.Id,
            EncounterId: flowsheet.EncounterId,
            ApprovalDate: flowsheet.ApprovalDate,
            ApprovedByEmployeeId: flowsheet.ApprovedByEmployeeId,
            Template: new FlowsheetTemplate(flowsheet.Template),
            CreationDate: flowsheet.CreationDate,
            CreatedByEmployeeId: flowsheet.CreatedByEmployeeId,
            EventHistory: flowsheet.EventHistory
        })) ?? [];

        // update note model
        const patientId = response.PatientId;
        store.FlowsheetModels[patientId] = store.FlowsheetModels[patientId] ?? [];

        for (const flowsheetSummary of flowsheets) {
            const index = store.FlowsheetModels[patientId].findIndex(p => p.get("flowsheetId") === flowsheetSummary.Id);

            if (index !== -1) {
                store.FlowsheetModels[patientId][index] = store.FlowsheetModels[patientId][index].set("flowsheetSummary", flowsheetSummary);
            }
            else {
                store.FlowsheetModels[patientId].push(Immutable.fromJS({
                    encounterId: flowsheetSummary.EncounterId,
                    flowsheetId: flowsheetSummary.Id,
                    flowsheetSummary
                }));
            }
        }
    }
}

export { FlowsheetsResponseHandler };
